<div class="modal fade" id="dialogModeloAta" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Modelo de Ata</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row">
          <div class="col-10 pr-1">
            <textarea [(ngModel)]="modelo" [ngModelOptions]="{standalone: true}" class="form-control"
              style="height: calc(100vh - 12rem)"></textarea>
          </div>
          <div class="col-2 pl-0">
            <h6 class="text-primary ml-3 mt-3">Tags disponíveis</h6>
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-2" *ngFor="let tag of tags">
                <span class="small text-muted" [title]="tag.descricao"><{{tag.tag}}></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Fechar</button>
      </div>
    </div>
  </div>
</div>